<div class="product-hero-banner grid align-center padding-horizontal-medium padding-bottom-medium document-template padding-vertical-xxbig">
  <div class="cell cell-large-col-span-7 cell-medium-col-span-12 flex flex-column flex-items-start">
    <mat-chip-set *ngIf="data.settings?.capsule" class="margin-bottom-xxsmall">
      <mat-chip class="padding-horizontal-small">
        <span class="text-small text-white">{{ data.settings?.capsule }}</span></mat-chip>
    </mat-chip-set>
    <h1 class="display-medium margin-bottom-medium">{{ data.settings?.heading }}</h1>
    <p class="text-large margin-bottom-medium" [innerHTML]="data.settings?.content"></p>
    <div class="margin-bottom-small product-hero-banner-button-container">
      <button *ngFor="let button of data.settings?.buttons" (click)="startQuoteEvent.emit(button.link)" mat-flat-button color="primary" class="margin-right-xsmall product-hero-banner-button margin-bottom-xsmall">{{ button.label }}</button>
    </div>
    <div
        id="trustbox-rating-1"
        class="trustpilot-widget"
        data-locale="en-GB"
        data-style-height="40px"
        data-style-width="100%"
        data-theme="light"
        data-stars="3,4,5"
        data-tags="SelectedReview"
        data-schema-type="Organization">
    </div>
  </div>
  <div *ngIf="data.settings?.brandIcon" class="product-hero-banner-image cell cell-large-col-span-5 cell-medium-col-span-8" [ngStyle]="{backgroundImage: 'url(' + data.settings?.image + ')'}">
    <img class="product-hero-banner-icon" [src]="data.settings?.brandIcon" width="72" height="72">
  </div>
</div>